import { useTranslation } from 'react-i18next'

import { Select } from '@chakra-ui/react'

const SelectFilter = ({ value, setValue, options = [] }) => {
  const { t } = useTranslation()

  return (
    <Select
      placeholder={t('TABLE_FILTER_ALL')}
      value={value ?? ''}
      onChange={(e) => {
        setValue(e.target.value)
      }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
}

export default SelectFilter
